import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { MailSortHelper } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
/**
 *
 * Returns a flag indicating whether to show the circle personas in this table
 * 1. Hide sender images in message list option is disabled
 * 2. if in search state, current scope is not drafts or sentitems
 * 3. current folder is not drafts, sentitems
 * 4. current table is not sorted by a multi value sort such as "From"
 * @param tableQuery - the table query
 */
export default function shouldTableShowCirclePersonas(tableQuery) {
    if (getIsBitSet(8 /* HideSenderImage */)) {
        return false;
    }
    else if (tableQuery.type == 1 /* Search */) {
        var searchTableQuery = tableQuery;
        if (tableQuery.scenarioType === 'persona') {
            // For persona scenario we want to align to results from persona search folder and show circle personas always
            return true;
        }
        return (((searchTableQuery.searchScope.kind == "PrimaryMailbox" /* PrimaryMailbox */ &&
            searchTableQuery.searchScope.folderId != folderNameToId('drafts') &&
            searchTableQuery.searchScope.folderId != folderNameToId('sentitems')) ||
            searchTableQuery.searchScope.kind == "ArchiveMailbox" /* ArchiveMailbox */ ||
            searchTableQuery.searchScope.kind == "SharedFolders" /* SharedFolders */) &&
            isMailFeatureEnabled('sea-circlePersonas'));
    }
    else {
        return (tableQuery.folderId != folderNameToId('drafts') &&
            tableQuery.folderId != folderNameToId('sentitems') &&
            !MailSortHelper.isTableMultiValueSort(tableQuery));
    }
}
//# sourceMappingURL=shouldTableShowCirclePersonas.js.map